import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Header from "../header/Header";
import Sidebar from "../sidebar/Sidebar";
import AccessHistoryService from "./AccessHistoryService";
import { useHistory } from "react-router-dom";
import { useReactToPrint } from "react-to-print";


/**
 * @author AndréK
 * 04/08/2022
 */


const useStyles = makeStyles((theme) => ({
    desktop: {
        display: "flex",
    },
}));

const Layout = React.forwardRef((props, ref) => {
    const classes = useStyles();
    const history = useHistory();

    //Access History
    useEffect(() => {
        //Get the current path and the current user
        const pageName = window.location.pathname.replace("/UI", ""); //remove the UI from path (used on production server)
        const userId = sessionStorage.getItem("userId");

        const data = { pageName: pageName, userId: userId };

        AccessHistoryService.validateAndRegister(data).catch((e) => {
            //Check if the token has expired (status code 401 - unauthorized)
            if (e.request.status + "" === "401") {
                console.log("Access History not ok");
                //if expired then go to the login page, and reset stored login and token values
                history.push("/login");
                sessionStorage.clear();
            } else {
                history.push("/home");
            }
        });

    }, [window.location.pathname]);

    const [isPrinting, setIsPrinting] = useState(false);
    const componentRef = useRef();

    const handleAfterPrint = () => {
        setIsPrinting(!isPrinting);
    };

    const makePrint = useReactToPrint({
        content: () => componentRef.current,

        onAfterPrint: handleAfterPrint,
    });

    useEffect(() => {
        if (isPrinting) {
            makePrint();
        }
    }, [isPrinting]);


    return (
        <>
            <div className={classes.desktop} ref={ref}>
                <Grid item style={{ marginRight: 60 }}>
                    <div
                        style={!props.print ? { display: "block" } : { display: "none" }}
                    >
                        <Sidebar />
                    </div>
                </Grid>
                <Grid container direction="column">
                    <div
                        style={!props.print ? { display: "block" } : { display: "none" }}
                    >
                        <Header />
                    </div>
                    <div style={{ marginLeft: "25px", marginRight: "15px"}}>
                        {props.children}
                    </div>
                </Grid>
            </div>
        </>
    );
});

Layout.propTypes = {
    fields: PropTypes.node,
};

export default Layout;
